import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AppFrame from "../../Appframe/AppFrame";
import layout from "../../../styles/layout";

import { Paper, Button } from "@material-ui/core";

import colors, { colorsV2 } from "../../../styles/colors";
import Title from "../../../components/common/Title";

const OrganizationReports = (props) => {
  console.log("PROPS", props);
  return (
    <AppFrame
      auth={props.auth}
      header="Organization Reporting"
      optionsType="organizationReporting"
      whiteLabelSettings={props.whiteLabelSettings}
    >
      <Title text1="" text2="" goBack={() => props.history.goBack()} />
      <Paper
        style={{
          margin: 30,
          padding: 20,
          borderColor: colorsV2.primary,
          borderWidth: 2,
          borderStyle: "solid",
        }}
        elevation={3}
      >
        <h1 style={{ marginTop: 5 }}>Provider Activity</h1>
        <p>
          Find information about each provider in your organization and their
          case load.
        </p>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
        >
          <Button
            onClick={() => {
              let link = `/org-reports/org-overview-report`;
              props.history.push(link);
            }}
            variant="outlined"
          >
            Go To Report
          </Button>
        </div>
      </Paper>
      <Paper
        style={{
          margin: 30,
          padding: 20,
          borderColor: colorsV2.primary,
          borderWidth: 2,
          borderStyle: "solid",
        }}
        elevation={3}
      >
        <h1 style={{ marginTop: 5 }}>RTM Billing</h1>
        <p>
          Find information about your organizations current RTM patients and
          billing status.
        </p>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
        >
          <Button
            onClick={() => {
              let link = `/org-reports/org-rtm-billing`;
              props.history.push(link);
            }}
            variant="outlined"
          >
            Go To Report
          </Button>
        </div>
      </Paper>
    </AppFrame>
  );
};

function mapStateToProps({ user, organization, whiteLabelSettings }, props) {
  return { user, organization, whiteLabelSettings, ...props };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, null)(OrganizationReports);



// WEBPACK FOOTER //
// ./src/layout/reporting/OrgReporting/OrganizationReports.js